export const Bio = {
    name: "Harry Le",
    roles: [
        "Front End Developer",
        "Reactjs Developer",
        "UI/UX Designer",
        "Graphic Designer",
    ],
    description:
        "I decided to look for new challenges in both coding and designing fields although my university major is Computer Science. With the knowledge and abilities I have, I am ready to do my best. I believe I could portray my passion through my work.",
    github: "https://github.com/HoangLeCoder",
    resume: "https://drive.google.com/file/d/1ffZrcMcn8UatXGIaautbbqpV7ADNaETA/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    twitter: "https://twitter.com/RishavChanda",
    insta: "https://www.instagram.com/rishav_chanda/",
    facebook: "https://www.facebook.com/rishav.chanda.165/",
};

export const skills = [
    {
        title: "Frontend",
        skills: [
            {
                name: "React Js",
                image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
            },
            {
                name: "Tailwind CSS",
                image: "https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg",
            },
            {
                name: "Redux",
                image: "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
            },
            // {
            //   name: "Next Js",
            //   image:
            //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
            // },

            {
                name: "Bootstrap",
                image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/1280px-Bootstrap_logo.svg.png",
            },
            {
                name: "Framer motion",
                image: "https://seeklogo.com/images/F/framer-motion-logo-DA1E33CAA1-seeklogo.com.png",
            },
            {
                name: "Vite",
                image: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Vitejs-logo.svg/1039px-Vitejs-logo.svg.png",
            },

            /*
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      }, */
            // {
            //   name: "Flutter",
            //   image:
            //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
            // },
        ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png",
        },
        {
          name: "Graph Ql",
          image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
        },
        // {
        //   name: "Python",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        // },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Postgresql",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
      ],
    },
    {
        title: "Design",
        skills: [
            {
                name: "Illustrator",
                image: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Adobe_Illustrator_CC_icon.svg/2101px-Adobe_Illustrator_CC_icon.svg.png",
            },
            {
                name: "PhotoShop",
                image: "https://seeklogo.com/images/A/adobe-photoshop-logo-7B88D7B5AA-seeklogo.com.png",
            },
            {
                name: "Canva",
                image: "https://seeklogo.com/images/C/canva-logo-B4BE25729A-seeklogo.com.png",
            },
            {
                name: "Blender",
                image: "https://seeklogo.com/images/B/blender-logo-91B66CA31F-seeklogo.com.png",
            },
            {
                name: "Clipchamp",
                image: "https://seeklogo.com/images/M/microsoft-clipchamp-logo-51D92AEEAF-seeklogo.com.png",
            },
            {
                name: "Figma",
                image: "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
            },
            {
                name: "Protopie",
                image: "https://seeklogo.com/images/P/protopie-logo-A51D8D3BEE-seeklogo.com.png",
            },
        ],
    },
    {
        title: "Programming Language",
        skills: [
            // {
            //     name: "Git",
            //     image: "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
            // },
            // {
            //     name: "GitHub",
            //     image: "https://icon-library.com/images/2018/1164606_telegram-icon-github-icon-png-white-png-download.png",
            // },
            // {
            //     name: "Netlify",
            //     image: "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
            // },
            // {
            //     name: "VS Code",
            //     image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
            // },
            {
                name: "HTML",
                image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
            },
            {
                name: "CSS",
                image: "https://www.cdnlogo.com/logos/c/18/css.svg",
            },
            {
                name: "JavaScript",
                image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
            },
            {
                name: "Sass",
                image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Sass_Logo_Color.svg/1280px-Sass_Logo_Color.svg.png",
            },
            {
                name: "Graph Ql",
                image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
            },
            {
                name: "Java",
                image: "https://seeklogo.com/images/J/java-logo-7F8B35BAB3-seeklogo.com.png",
            },
            {
                name: "Kotlin",
                image: "https://seeklogo.com/images/K/kotlin-logo-30C1970B05-seeklogo.com.png",
            },
            {
                name: "C++",
                image: "https://seeklogo.com/images/C/c-logo-43CE78FF9C-seeklogo.com.png",
            },
        ],
    },
    {
        title: "Others Code skill",
        skills: [
            {
                name: "Git",
                image: "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
            },
            {
                name: "GitHub",
                image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
            },
            {
                name: "Gitlab",
                image: "https://seeklogo.com/images/G/gitlab-logo-757620E430-seeklogo.com.png",
            },
            // {
            //     name: "Docker",
            //     image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
            // },
            {
                name: "Netlify",
                image: "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
            },
            {
                name: "Hostinger",
                image: "https://seeklogo.com/images/H/hostinger-logo-6B346B6FBB-seeklogo.com.png",
            },
            {
                name: "VS Code",
                image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
            },
            {
                name: "Eclipse",
                image: "https://seeklogo.com/images/E/eclipse-logo-85FE4BEA34-seeklogo.com.png",
            },
            {
                name: "Android Studio",
                image: "https://seeklogo.com/images/A/android-studio-logo-1EE788C6EC-seeklogo.com.png",
            },
            
            // {
            //     name: "Postman",
            //     image: "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
            // },
            // {
            //     name: "Adobe XD",
            //     image: "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
            // },
            // {
            //     name: "Figma",
            //     image: "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
            // },
        ],
    },
    {
        title: "Task Management",
        skills: [
            {
                name: "Trello",
                image: "https://seeklogo.com/images/T/trello-logo-CE7B690E34-seeklogo.com.png",
            },
            {
                name: "Redmine",
                image: "https://enclaive.io/wp-content/uploads/2021/09/Redmine_logo.svg",
            },
            {
                name: "Jira",
                image: "https://seeklogo.com/images/J/jira-logo-C71F8C0324-seeklogo.com.png",
            },
            {
                name: "Notion",
                image: "https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png",
            },
        ],
    },
];

export const experiences = [
    {
        id: 0,
        img: "https://cdn-new.topcv.vn/unsafe/150x/filters:format(webp)/https://static.topcv.vn/company_logos/cong-ty-tnhh-hiptech-62feebc944996.jpg",
        role: "Parttime UI/UX desginer",
        company: "HIPTECH Solution",
        date: "Aug 2023 - Now",
        desc: "Working as a UI/UX designer, I cover all the works related to Product Design such as Sketch, Wireframe, draw Sitemap, create Mockup-wireframe and add some prototype to make it realistic. Besides that, I also use Protopie to add animation to component in frames of a Figma file.",
        skills: [
            "Figma",
            "Figjam",
            "Protopie",
        ],
        // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
    {
        id: 0,
        img: "https://cdn-new.topcv.vn/unsafe/150x/filters:format(webp)/https://static.topcv.vn/company_logos/cong-ty-tnhh-hiptech-62feebc944996.jpg",
        role: "Front End Developer Intern",
        company: "HIPTECH Solution",
        date: "June 2023 - Sep 2023",
        desc: "Working on the frontend of the web application using ReactJS, Tailwindcss to create company internal tools and redesign company website using React",
        skills: [
            "ReactJS",
            "Tailwindcss",
            "Firebase",
            "Redux",
            "Bootstrap",
            "Vite",
            "HTML",
            "CSS",
            "Sass",
            "JavaScript",
        ],
    },
    {
        id: 1,
        img: "https://scontent.fsgn1-1.fna.fbcdn.net/v/t39.30808-6/368198625_832492162106190_7484709022791135552_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=a2f6c7&_nc_ohc=7MNBeQi-C70AX-agvWn&_nc_oc=AQnL9kG0ChDqhaDM0Z1z8P9khEPMneqRG9k4S38Gzb_8rcNwb5_AiRqFWT1leYWqm1E&_nc_ht=scontent.fsgn1-1.fna&oh=00_AfD1bRJyBFN3_I5h647EhxiJddJDZgjoYaDlJkAQmR-Psw&oe=651B34B7",
        role: "Graphic Design Specialist",
        company: "IECenter - English Centre",
        date: "Jul 2022 - Apr 2023",
        desc: "As a Graphic Design Specialist at IECenter, I design media publications with company identity like Banners, Posters, Logos, Brochures. Fanpage Admin: design social posts and plan events related to the occasion and come up with a suitable design theme to attract web viewers, design Slide Education Materials for Teaching purposes, design Company landing page.",
        skills: [
            "Adobe Photoshop",
            "Adobe Illustrator",
            "Adobe After Effects",
            "Clipchamp",
            "Microsoft Powerpoint",
            "Facebook Adminboard",
            "Figma",
            "Wordpress",
        ],
    },
    {
        id: 2,
        img: "https://scontent.fsgn1-1.fna.fbcdn.net/v/t1.18169-9/10574350_751327188272867_4254346426317635487_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=d57657&_nc_ohc=hLymWoWF3tUAX9GDjPv&_nc_ht=scontent.fsgn1-1.fna&oh=00_AfCrtx8zYETpUrJp_LM8IQYHW_k2gO2K3EgvS_rdBHBj8g&oe=653D0EF2",
        role: "Teaching Assistant",
        company: "International University - VNU",
        date: "Feb 2022 - Jun 2023 (3 semesters)",
        desc: "As an Teaching Assistant in Critical Thinking course at my university. I help teachers manage students' scores and answer questions from learners.",
    },
    {
        id: 3,
        img: "https://harrydevign.netlify.app/assets/design-fa27266b.png",
        role: "Freelance Graphic Designer",
        company: "Freelance",
        date: "Mar 2021 - Jul 2022",
        desc: "As an Freelance Graphic Designer on Facebook/Zalo, I receive orders from customers on facebook and zalo groups to create media publications like Banners, Posters, Logos, Brochures. Design Application: Adobe Illustrator - Photoshop - After Effects. Sketch - Prototype - Wireframe the User Interface (UI) using Figma. Basic video editing using Canva, Powerpoint or Microsoft Clipchamp.",
        skills: [
            "Adobe Photoshop",
            "Adobe Illustrator",
            "Figma",
            "Figjam",
            "Clipchamp",
        ],
    },
    {
        id: 4,
        img: "https://scontent.fsgn1-1.fna.fbcdn.net/v/t39.30808-6/310488203_477521274412114_4229854362507878399_n.png?_nc_cat=106&ccb=1-7&_nc_sid=a2f6c7&_nc_ohc=GnK95lpaBRcAX8q0HFf&_nc_ht=scontent.fsgn1-1.fna&oh=00_AfCJLMBRzrIQ1lWOpgzlWDYPyIilg3kBAO6VBjxsFVSeSw&oe=651B28DD",
        role: "Powerpoint Freelance Designer",
        company: "9slide Fanpage",
        date: "Oct 2020 - Mar 2021",
        desc: "As an Powerpoint Freelance Designer at 9slide facebook group, I Receive orders from customers on facebook and zalo groups to create presentation slides. Consulting content layout for customers to create an attractive presentation for viewers. Use powerpoint to create media publications such as slides, posters, banners and short videos.",
        skills: [
            "Microsoft Powerpoint",
            "Canva",
        ],
    },
];

export const education = [
    {
        id: 0,
        img: "https://media.licdn.com/dms/image/C560BAQE4UC9Z_k3c7A/company-logo_200_200/0/1579422507409?e=1692230400&v=beta&t=HJssPsrwwkAJAsvFiVIYPdM8GzUuuSK5YlATKgLx3Bc",
        school: "Kalinga Institute of Industrial Technology, Bhubaneswar",
        date: "Oct 2021 - Sep 2025",
        grade: "8.71 CGPA",
        desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
        degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    },
    {
        id: 1,
        img: "https://methodistschool-dankuni.webs.com/NEW%20BADGE.jpg",
        school: "Methodist School, Dankuni",
        date: "Apr 2019 - Apr 2025",
        grade: "88.2%",
        desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
        degree: "ISC(XII), Science with Computer",
    },
    {
        id: 2,
        img: "https://methodistschool-dankuni.webs.com/NEW%20BADGE.jpg",
        school: "Methodist School, Dankuni",
        date: "Apr 2017 - Apr 2019",
        grade: "92.3%",
        desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
        degree: "ICSC(X), Science with Computer",
    },
];

export const projects = [
    {
        id: 9,
        title: "Trackify",
        date: "Jun 2023 - Jul 2023",
        description:
            "Trackify is a web application designed to streamline task management and enhance productivity in the workplace. It provides a user-friendly interface for employers to keep track of their employees' daily work activities and empowers employees to log their tasks efficiently. \nAdmin Credentials: # Email: testadmin@gmail.com #Password- 123@testadmin, Employee Credentials:	#Email: testemployee@gmail.com	#Password- 123@Testemployee",
        image: "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
        tags: [
            "Docker",
            "AWS",
            "DuckDNS",
            "Eslint",
            "Husky",
            "CI/CD",
            "React Js",
            "MongoDb",
            "Node Js",
            "Express Js",
            "Redux",
        ],
        category: "web app",
        github: "https://github.com/rishavchanda/Trackify",
        webapp: "https://trackify.duckdns.org",
    },
    {
        id: 0,
        title: "Podstream",
        date: "Apr 2023 - May 2023",
        description:
            "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
        image: "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
        tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
        category: "web app",
        github: "https://github.com/rishavchanda/Podstream",
        webapp: "https://podstream.netlify.app/",
        member: [
            {
                name: "Rishav Chanda",
                img: "https://avatars.githubusercontent.com/u/64485885?v=4",
                linkedin:
                    "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
                github: "https://github.com/rishavchanda/",
            },
            {
                name: "Upasana Chaudhuri",
                img: "https://avatars.githubusercontent.com/u/100614635?v=4",
                linkedin:
                    "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
                github: "https://github.com/upasana0710",
            },
        ],
    },
    {
        id: 1,
        title: "Vexa",
        date: "Oct 2022 - Present",
        description:
            "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
        image: "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
        tags: [
            "React Js",
            "MongoDb",
            "Node Js",
            "Express Js",
            "Redux",
            "NodeMailer",
        ],
        category: "web app",
        github: "https://github.com/rishavchanda/Project-Management-App",
        webapp: "https://vexa-app.netlify.app/",
    },
    {
        id: 2,
        title: "Brain Tumor Detection",
        date: "Jan 2023 - Mar 2023",
        description:
            "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
        image: "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
        tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
        category: "machine learning",
        github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
        webapp: "https://brain-tumor.netlify.app/",
        member: [
            {
                name: "Rishav Chanda",
                img: "https://avatars.githubusercontent.com/u/64485885?v=4",
                linkedin:
                    "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
                github: "https://github.com/rishavchanda/",
            },
            {
                name: "Upasana Chaudhuri",
                img: "https://avatars.githubusercontent.com/u/100614635?v=4",
                linkedin:
                    "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
                github: "https://github.com/upasana0710",
            },
        ],
    },
    {
        id: 3,
        title: "Buckoid",
        date: "Dec 2021 - Apr 2022",
        description:
            "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
        image: "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
        tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
        category: "android app",
        github: "https://github.com/rishavchanda/Buckoid-Android-App",
        webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
    },
    {
        id: 10,
        title: "Job Finding App",
        date: "Jun 2023 - Jul 2023",
        description:
            "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
        image: "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
        tags: ["React Native", "JavaScript", "Axios"],
        category: "android app",
        github: "https://github.com/rishavchanda/Job-finder-App",
        webapp: "https://github.com/rishavchanda/Job-finder-App",
    },
    {
        id: 4,
        title: "Whatsapp Clone",
        date: "Jul 2021",
        description:
            "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
        image: "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
        tags: ["React Js", "Firebase", "Firestore", "Node JS"],
        category: "web app",
        github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
        webapp: "https://whatsapp-clone-rishav.web.app",
    },
    {
        id: 5,
        title: "Todo Web App",
        date: "Jun 2021",
        description:
            " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
        image: "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
        tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
        category: "web app",
        github: "https://github.com/rishavchanda/Todo-Web-App",
        webapp: "https://rishav-react-todo.netlify.app/",
    },
    {
        id: 6,
        title: "Breaking Bad",
        date: "Jun 2021",
        description:
            "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
        image: "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
        tags: ["React Js", "API", "Axios", "Node JS"],
        category: "web app",
        github: "https://github.com/rishavchanda/Breaking-Bad",
        webapp: "https://breaking-bad-webapp.netlify.app",
    },
    {
        id: 7,
        title: "Quiz App",
        date: "Dec 2020 - Jan 2021",
        description:
            "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
        image: "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
        tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
        category: "android app",
        github: "https://github.com/rishavchanda/Quiz-Earn",
        webapp: "https://github.com/rishavchanda/Quiz-Earn",
    },
    {
        id: 8,
        title: "Face Recognition",
        date: "Jan 2021",
        description:
            "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
        image: "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
        tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
        category: "machine learning",
        github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
        webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    },
];

export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
];
